// eslint-disable-next-line import/extensions
import store from '~/store'
import experiment from '~/plugins/experiments.js'
import commonHelper from '~/global_helper/helpers.js'
import CONSTANTS from '~/global_helper/constants.js'

export default async (to, from, next) => {
	if (store.getters['Auth/check']) {
		const experimentConfig = {}
		let needUpdate = null
		store.dispatch('Auth/fetchUser').then(() => {
			const user = store.getters['Auth/user']
			// Experiment setup example
			// const experimentLaunchStoreButton = user.experiments?.launch_store_button
			// if (experimentLaunchStoreButton === undefined) {
			// 	experimentConfig.launch_store_button = commonHelper.isProbable(0.5) ? CONSTANTS.EXPERIMENT_GROUP.TREATMENT : CONSTANTS.EXPERIMENT_GROUP.CONTROL
			// 	needUpdate = true
			// }
			needUpdate = false

			const getMeOrientedV1Jan25 = user.experiments?.get_me_oriented_v1_jan_25
			if (getMeOrientedV1Jan25 === undefined) {
				experimentConfig.get_me_oriented_v1_jan_25 = commonHelper.isProbable(0.5)
					? CONSTANTS.EXPERIMENT_GROUP.TREATMENT
					: CONSTANTS.EXPERIMENT_GROUP.CONTROL
				needUpdate = true
			}

			const whereAreMySalesFrom = user.experiments?.where_are_my_sales_from_take2
			if (whereAreMySalesFrom === undefined) {
				experimentConfig.where_are_my_sales_from_take2 = commonHelper.isProbable(0.5)
					? CONSTANTS.EXPERIMENT_GROUP.TREATMENT
					: CONSTANTS.EXPERIMENT_GROUP.CONTROL
				needUpdate = true
			}

			const autoDmButtons = user.experiments?.auto_dm_buttons
			if (autoDmButtons === undefined) {
				experimentConfig.auto_dm_buttons = commonHelper.isProbable(0.5)
					? CONSTANTS.EXPERIMENT_GROUP.TREATMENT
					: CONSTANTS.EXPERIMENT_GROUP.CONTROL

				needUpdate = true
			}

			const diffTime = Math.abs(new Date() - new Date(user.created_at * 1000))
			const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
			const followers = Math.max(user.tags.instagram?.data?.followers ?? 0, user.tags.tiktok?.data?.followers ?? 0)
			if (diffDays < 14) {
				if ((user.tags.instagram?.data?.followers || user.tags.tiktok?.data?.followers) && followers < 1000) {
					const stoneExclusiveLiveCoachingCall = user.experiments?.stone_exclusive_live_coaching_call
					if (stoneExclusiveLiveCoachingCall === undefined) {
						experimentConfig.stone_exclusive_live_coaching_call = commonHelper.isProbable(0.5) ? 'treatment' : 'control'
						needUpdate = true
					}
				}
			}

			// Check if the user has been assigned treatment or control for the experiment
			const accountDeletionV082025 = user.experiments?.account_deletion_v082025

			// if not assigned, assigned with probability or environment
			if (accountDeletionV082025 === undefined) {
				experimentConfig.account_deletion_v082025 = CONSTANTS.EXPERIMENT_GROUP.TREATMENT
				needUpdate = true
			}

			if (needUpdate) {
				experiment(experimentConfig)
				store.dispatch('Auth/fetchUser')
			}
		})
	}
	next()
}
